"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const lodash_1 = require("lodash");
const lp_components_1 = require("lp-components");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const redux_1 = require("redux");
const apiActions = __importStar(require("api-actions"));
const components_1 = require("components");
const config_1 = require("config");
const local_storage_1 = require("local-storage");
const merchant_management_v1_api_1 = require("merchant-management-v1-api");
const utils_1 = require("utils");
const merchantActions = __importStar(require("../../actions"));
const forms_1 = require("../../forms");
const reducer_1 = require("../../reducer");
const actions = __importStar(require("../actions"));
const PaymentDetailsForm_1 = __importDefault(require("../forms/PaymentDetailsForm"));
const reducer_2 = require("../reducer");
function PaymentDetails({ setPaymentDetails, currentLocation, allLocations, currentLocationIndex, setCurrentLocationIndex, fetchLocationDetails, accountVerification, getLenderSettings, lenderSettings, }) {
    const history = (0, react_router_dom_1.useHistory)();
    const { id, buyerId } = (0, react_router_dom_1.useParams)();
    const location = (0, react_router_dom_1.useLocation)();
    const showSaleInText = lenderSettings?.lenderProductType != 'LTO';
    const SALE_TEXT = showSaleInText ? 'Available Credit' : 'Available Amount';
    const CREDIT_TEXT = showSaleInText ? 'Credit Limit' : 'Account Limit';
    accountVerification = location.state?.accountVerification;
    const [displayLocationSelector, setDisplayLocationSelector] = (0, react_1.useState)(false);
    const closeLocationSelector = () => setDisplayLocationSelector(false);
    const { data: accountDetail, isFetching } = (0, merchant_management_v1_api_1.useGetMerchantManagementV1LookupsAccountsAlphaeonAccountNumberQuery)({
        alphaeonAccountNumber: id,
        locationId: String(currentLocation.locationId),
    });
    const { name, alphaeonAccountNumber = '', availableCreditLimit, address, ssnLast4, creditLimit, consumerCreditInstrumentId, consumerCreditInstrumentType, derogatoryInd, internalRiskReason, lenderName, authorizedBuyers, digitalReceiptEnabledStore, digitalReceiptEnabledCustomer, } = accountDetail || {};
    const isInstallmentProduct = consumerCreditInstrumentType === 'installment';
    const shouldDisplayChangeLocationButton = !isInstallmentProduct;
    (0, react_1.useEffect)(() => {
        lenderName && getLenderSettings(lenderName, currentLocation.locationId);
    }, [lenderName]);
    (0, react_1.useEffect)(() => {
        if (internalRiskReason?.startsWith('RISKY') && (0, lodash_1.isNil)(accountVerification)) {
            history.push({
                pathname: `${config_1.ACCOUNT_VERIFICATION_URL}`,
                state: {
                    accountDetail,
                },
            });
        }
    }, [accountDetail, internalRiskReason]);
    (0, react_1.useEffect)(() => {
        if (accountDetail) {
            (0, utils_1.reportAction)('PaymentDetails', {
                componentName: 'PaymentDetails',
                actionType: 'View',
                actionURL: window.location.pathname,
                actionData: {
                    alphaeonAccountNumber: accountDetail.alphaeonAccountNumber,
                    locationStoreNumber: currentLocation.adsStoreNumber.toString(),
                    locationId: currentLocation.locationId,
                },
            });
        }
    }, [accountDetail]);
    if (isFetching) {
        return (0, jsx_runtime_1.jsx)(components_1.Spinner, { centerPage: true });
    }
    if (availableCreditLimit == 0) {
        history.push(`${config_1.ACCOUNT_DETAIL_URL}${alphaeonAccountNumber}`);
    }
    if ((0, lodash_1.isUndefined)(accountDetail)) {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "account-lookup m-t-30", children: [(0, jsx_runtime_1.jsx)("h3", { children: "Error Fetching Account Detail" }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "/", children: "GO HOME" })] }));
    }
    const buyer = (0, lodash_1.isNil)(buyerId) || buyerId == '0'
        ? null
        : authorizedBuyers?.find((buyer) => buyer.accountMemberId == Number(buyerId));
    const accountMemberId = (0, lodash_1.isNil)(buyerId) || buyerId == '0'
        ? accountDetail.accountMemberId
        : parseInt(buyerId);
    const handleSubmit = (values) => {
        const lineItems = [];
        let key = 0;
        while (true) {
            const currentType = values[`itemType${key}`];
            const currentAmount = values[`itemAmount${key}`];
            if (currentType) {
                const lineItem = {
                    name: currentType.label,
                    productId: currentType.value,
                    productCatalogId: 1,
                    amount: Number(currentAmount.replace(/,/g, '')),
                    quantity: 1,
                };
                lineItems.push(lineItem);
                key++;
            }
            else {
                break;
            }
        }
        const data = {
            ...values,
            accountMemberId,
            consumerCreditInstrumentId,
            consumerCreditInstrumentType,
            name,
            availableCreditLimit,
            address,
            ssnLast4,
            creditLimit,
            alphaeonAccountNumber,
            buyer,
            ...(lineItems.length > 0 ? { lineItems } : {}),
        };
        setPaymentDetails(data);
        history.push(config_1.PLAN_SELECTION_URL);
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { className: "account-lookup m-t-30", children: [(0, jsx_runtime_1.jsx)(components_1.H1, { children: "Payment Details, Step 1 of 3" }), (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)("div", { className: "account-summary summary refund-complete", children: [buyer && ((0, jsx_runtime_1.jsx)(components_1.AuthBuyerSaleCard, { paymentDetails: { ...accountDetail, buyer }, currentLocation: currentLocation })), !buyer && ((0, jsx_runtime_1.jsx)("div", { className: "summary__card card m-t-30", children: (0, jsx_runtime_1.jsx)("div", { className: "card-content", children: (0, jsx_runtime_1.jsxs)("div", { className: "summary__account-info", children: [(0, jsx_runtime_1.jsxs)(components_1.H2, { variant: "headline-medium", children: [name?.firstName, " ", name?.lastName] }), (0, jsx_runtime_1.jsxs)("div", { className: "info-container sub-title", children: [(0, jsx_runtime_1.jsx)(components_1.P, { variant: "body-large", className: "mar-y-8", children: "Account Number:" }), (0, jsx_runtime_1.jsx)(components_1.AccountNumber, { accountNumberString: alphaeonAccountNumber })] }), (0, jsx_runtime_1.jsxs)("div", { className: "card-main", children: [(0, jsx_runtime_1.jsxs)("div", { className: "card-main__left", children: [(0, jsx_runtime_1.jsx)("div", { className: "info-container", children: (0, jsx_runtime_1.jsxs)(components_1.P, { variant: "body-large", className: "mar-y-8", children: [(0, jsx_runtime_1.jsx)("strong", { children: SALE_TEXT }), ' ', (0, utils_1.formatCurrency)(availableCreditLimit, 2)] }) }), (0, jsx_runtime_1.jsx)("div", { className: "info-container", children: (0, jsx_runtime_1.jsxs)(components_1.P, { variant: "body-large", className: "mar-y-8", children: [(0, jsx_runtime_1.jsx)("strong", { children: "Social Security Number" }), ' ', ssnLast4 ? `XXX-XX-${ssnLast4}` : 'N/A'] }) })] }), (0, jsx_runtime_1.jsxs)("div", { className: "card-main__right", children: [(0, jsx_runtime_1.jsx)("div", { className: "info-container", children: (0, jsx_runtime_1.jsxs)(components_1.P, { variant: "body-large", className: "mar-y-8", children: [(0, jsx_runtime_1.jsx)("strong", { children: CREDIT_TEXT }), ' ', (0, utils_1.formatCurrency)(creditLimit, 2)] }) }), (0, jsx_runtime_1.jsx)("div", { className: "info-container", children: (0, jsx_runtime_1.jsxs)(components_1.P, { variant: "body-large", className: "mar-y-8", children: [(0, jsx_runtime_1.jsx)("strong", { children: "Location " }), " ", currentLocation.name, " -", ' ', currentLocation.adsStoreNumber] }) }), shouldDisplayChangeLocationButton && ((0, jsx_runtime_1.jsx)("div", { className: "info-container", children: (0, jsx_runtime_1.jsx)("div", { className: "card-area mar-y-8", children: (0, jsx_runtime_1.jsx)(components_1.Button, { type: "button", onClick: () => setDisplayLocationSelector(!displayLocationSelector), className: "button-warn-outline", children: "Change Location" }) }) }))] })] })] }) }) })), (0, jsx_runtime_1.jsx)(PaymentDetailsForm_1.default, { lenderName: lenderName ?? '', creditLimit: String(creditLimit), handleSubmit: handleSubmit, derogatoryInd: derogatoryInd, internalRiskReason: internalRiskReason, showServiceDate: isInstallmentProduct, maxServiceDate: lenderSettings?.latestAllowedServiceDate ?? '', lenderProductType: lenderSettings?.lenderProductType, currentLocationId: currentLocation.locationId, minPurchaseAmount: lenderSettings?.minPurchaseAmount, maxPurchaseAmount: lenderSettings?.maxPurchaseAmount, digitalReceiptsAllowed: !!digitalReceiptEnabledStore && !!digitalReceiptEnabledCustomer })] }) })] }), displayLocationSelector && ((0, jsx_runtime_1.jsx)(lp_components_1.Modal, { onClose: closeLocationSelector, children: (0, jsx_runtime_1.jsx)(forms_1.LocationSelectorForm, { allLocations: allLocations, initialValues: { selectedLocationIndex: currentLocationIndex }, defaultValue: {
                        label: currentLocation.name,
                        value: currentLocationIndex,
                    }, onSubmit: ({ selectedLocationIndex, }) => {
                        closeLocationSelector();
                        fetchLocationDetails(allLocations[selectedLocationIndex.value].locationId).then((res) => (0, local_storage_1.setLocation)(res));
                        return setCurrentLocationIndex(selectedLocationIndex.value);
                    } }) }))] }));
}
function mapStateToProps(state) {
    return {
        currentLocation: reducer_1.selectors.currentLocation(state),
        allLocations: reducer_1.selectors.allLocations(state),
        currentLocationIndex: reducer_1.selectors.currentLocationIndex(state),
        lenderSettings: reducer_2.selectors.lenderSettings(state),
    };
}
const mapDispatchToProps = {
    setPaymentDetails: actions.setPaymentDetails,
    setCurrentLocationIndex: merchantActions.setCurrentLocationIndex,
};
const mapApiAuthToProps = {
    fetchLocationDetails: apiActions.fetchLocationDetails,
    getLenderSettings: apiActions.getLenderSettings,
};
exports.default = (0, redux_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, utils_1.withApiAuth)(mapApiAuthToProps))(PaymentDetails);
